<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="solution-time-line-cards-title" :field="fields?.title" tag="h2" />
      <div class="solution-time-line-cards-content">
        <div :class="listClass" v-if="fields?.list?.length > 0">
          <div
            class="solution-time-line-cards-content-list-item"
            v-for="item in fields?.list"
            :key="item.id"
          >
            <div class="solution-time-line-cards-content-list-item-content">
              <JssRichText
                class="solution-time-line-cards-content-list-item-title"
                :field="item?.fields?.title"
                tag="h3"
              />
              <JssRichText
                class="solution-time-line-cards-content-list-item-cardDesc"
                :field="item?.fields?.cardDesc"
              />
            </div>
            <div class="solution-time-line-cards-content-list-item-rest">
              <JssRichText
                class="solution-time-line-cards-content-list-item-timeText"
                :field="item?.fields?.timeText"
              />
              <JssRichText
                class="solution-time-line-cards-content-list-item-desc"
                :field="item?.fields?.desc"
              />
              <div
                class="solution-time-line-cards-content-list-item-button"
                @click="openModal(item)"
              >
                <siteButton v-bind="item?.fields?.button" :open-link="false" />
              </div>
              <AdaptiveImage
                class="solution-time-line-cards-content-list-item-image"
                :field="fields?.image"
                :isBackground="false"
                :lazy-load="false"
                :enableScrollDetection="false"
                :show="true"
              />
            </div>
          </div>
        </div>
      </div>
      <JssRichText class="solution-time-line-cards-footer" :field="fields?.footerText" />
    </ContentGrid>

    <!-- 弹窗 -->
    <Teleport to="body">
      <transition name="solution-time-line-cards-fade">
        <div
          v-if="modalVisible"
          class="solution-time-line-cards-modal-mask"
          @click.self="closeModal"
        >
          <div class="solution-time-line-cards-modal">
            <span class="solution-time-line-cards-modal-close" @click="closeModal">&times;</span>
            <div class="solution-time-line-cards-modal-body">
              <JssRichText :field="modalContent" />
            </div>
          </div>
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import utils from '@/utils';

export default {
  name: 'SolutionTimelineCards',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() =>
      utils.overall.baseComClass(props.fields, 'solution-time-line-cards')
    );

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    const listClass = computed(() => {
      const length = props.fields?.list?.length || 0;
      const base = 'solution-time-line-cards-content-list';
      if (length > 0 && length < 4) {
        return [base, `${base}--cols-${length}`];
      }
      return base;
    });

    // 弹窗
    const modalVisible = ref(false);
    const modalContent = ref(null);

    const openModal = (item) => {
      if (!item?.fields?.button?.fields?.openModal?.value) return;
      modalContent.value = item?.fields?.modalBody;
      modalVisible.value = true;
    };

    const closeModal = () => {
      modalVisible.value = false;
      modalContent.value = null;
    };

    return {
      rootClass,
      rootStyle,
      listClass,
      modalVisible,
      modalContent,
      openModal,
      closeModal,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.solution-time-line-cards {
  position: relative;
  width: 100%;
  background: #f8fafb;
  border-radius: 16px;
  padding: 40px 0;

  &-title {
    text-align: center;
    margin-bottom: 24px;
  }

  &-content {
    width: 100%;
    &-list {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    &-list-item {
      background: $white;
      border-radius: 12px;
      padding: 20px;
      display: flex;
      flex-direction: column;
      gap: 16px;

      &-content {
        background: #f0f7f4;
        border-radius: 8px;
        padding: 16px;
        display: flex;
        flex-direction: column;
      }

      &-title {
        font-size: 18px;
        font-weight: 600;
        color: #1a1a1a;
        line-height: 1.2;
      }

      &-cardDesc {
        font-size: 14px;
        color: #333333;
        line-height: 1.6;
        margin-top: 12px;
      }

      &-rest {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      &-timeText {
        font-size: 24px;
        font-weight: 700;
        color: #1a1a1a;
      }

      &-desc {
        font-size: 14px;
        color: #666666;
        line-height: 1.6;
      }

      &-image {
        width: 100%;
        max-width: 200px;
      }
    }
  }

  &-footer {
    font-size: 24px;
    color: $grey-black;
    font-weight: 700;
    line-height: 1.2;
    margin-top: 20px;
  }

  // 弹窗
  &-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 80vw;
    max-height: 60vh;
    background: $white;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    z-index: 1001;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &-mask {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1000;
    }

    &-close {
      position: absolute;
      top: 12px;
      right: 16px;
      font-size: 28px;
      line-height: 1;
      cursor: pointer;
      color: #999;
      z-index: 1;

      &:hover {
        color: #333;
      }
    }

    &-body {
      padding: 32px;
      overflow-y: auto;
      font-size: 16px;
      line-height: 1.6;
      color: #364153;
    }
  }

  @include tablet-landscape {
    padding: 60px 0;
    border-radius: 24px;

    &-title {
      margin-bottom: 40px;
    }

    &-content {
      &-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 24px;
        row-gap: 20px;

        &--cols-1 {
          grid-template-columns: repeat(1, 1fr);
        }

        &--cols-2 {
          grid-template-columns: repeat(2, 1fr);
        }

        &--cols-3 {
          grid-template-columns: repeat(3, 1fr);
        }
      }

      &-list-item {
        display: grid;
        grid-template-rows: subgrid;
        grid-row: span 2;
        padding: 24px;

        &-content {
          padding: 20px;
        }

        &-title {
          font-size: 20px;
        }

        &-cardDesc {
          font-size: 15px;
        }

        &-timeText {
          font-size: 28px;
        }

        &-desc {
          font-size: 15px;
        }
      }
    }
  }
}

// 弹窗过渡动画
.solution-time-line-cards-fade {
  &-enter-active,
  &-leave-active {
    transition: opacity 0.3s;

    .solution-time-line-cards-modal {
      transition: transform 0.3s;
    }
  }

  &-enter-from,
  &-leave-to {
    opacity: 0;

    .solution-time-line-cards-modal {
      transform: translate(-50%, -50%) scale(0.9);
    }
  }
}
</style>
